export class WP_Query {
  params: Record<string, unknown>;
  constructor(params: Record<string, unknown> = {}) { this.params = params; }
}
